<div class="onboarding-wrapper">
  @if (images) {
  <ngb-carousel>
    <ng-template ngbSlide>
      <div class="picsum-img-wrapper">
        <img
          class="onboarding-img img-fluid"
          [src]="images[0]"
          alt="Random first slide"
        />
      </div>
    </ng-template>
    <ng-template ngbSlide>
      <div class="picsum-img-wrapper">
        <img
          class="onboarding-img"
          [src]="images[1]"
          alt="Random second slide"
        />
      </div>
    </ng-template>
    <ng-template ngbSlide>
      <div class="picsum-img-wrapper">
        <img
          class="onboarding-img"
          [src]="images[2]"
          alt="Random third slide"
        />
      </div>
    </ng-template>
  </ngb-carousel>
  }
</div>
